import { Member, ProjectDocument, ProjectState, Task } from "@/types/project";
import { create } from "zustand";
// import api from '../utils/api';

export const useProjectStore = create<ProjectState>((set) => ({
  projects: null,
  selectedProject: null,
  selectedProjectDocuments: null,
  selectedProjectTasks: null,
  selectedProjectMembers: null,
  setSelectedProject: (id: string) =>
    set((state) => ({
      selectedProject: state?.projects?.find((project) => project.id === id),
    })),
  setSelectedProjectDocuments: (
    selectedProjectDocuments: ProjectDocument[] | null
  ) => set({ selectedProjectDocuments: selectedProjectDocuments }),
  setSelectedProjectTasks: (selectedProjectTasks: Task[] | null) =>
    set({ selectedProjectTasks: selectedProjectTasks }),
  setSelectedProjectMembers: (selectedProjectMembers: Member[] | null) =>
    set({ selectedProjectMembers: selectedProjectMembers }),
  setProjects: (projects: any) => set({ projects: projects }),
}));
